<input #uploader style="display: none" type="file" multiple class="form-control" (change)="onFileChange($event)" />

<div class="file-uploader" (click)="clickUploader(uploader)">
  <img src="assets/images/upload.svg" />
  <span *ngIf="required" class="asterisk"> *</span>
</div>
<ng-container *ngFor="let bigFile of filesTooBig">
  <div *ngIf="bigFile" class="error">{{ 'formErrors.fileSize' | translate }}</div>
</ng-container>
<ng-container *ngFor="let wrongFile of wrongExtensions">
  <div *ngIf="wrongFile" class="error">
    {{ 'formErrors.fileExtension' | translate: { extensions: getAllowedExtensionsString()} }}
  </div>
</ng-container>

<div *ngIf="uploadedFiles.length >= (numberOfFilesRequired ?? 0)" class="warning">{{ 'formErrors.fileMaxUpload' | translate }}</div>

<app-error-message *ngIf="formControl.errors && formControl.touched" type="file_upload" [validationErrors]="formControl.errors">
</app-error-message>

<div *ngFor="let file of uploadedFiles; let i = index" class="file">
  <img src="assets/images/file.svg" />

  <div class="file--name">
    {{ file.name }}
  </div>

  <div class="file--size">
    {{ fileSize(file.size) }}
  </div>

  <div class="file--trash" (click)="deleteSelected(i)">
    <img src="assets/images/trash.svg" />
  </div>
</div>
<div class="file" *ngFor="let uploadedFileLink of uploadedFileLinks; let i = index">
  <a [href]="uploadedFileLink" target="_blank">{{ uploadedFileLink }}</a>
  <div class="file--trash" (click)="deleteUploadedFile(i, uploadedFileLink)">
    <img src="assets/images/trash.svg" />
  </div>
</div>
